import { render, staticRenderFns } from "./TaskGroup.vue?vue&type=template&id=8d8d504e&scoped=true&"
import script from "./TaskGroup.vue?vue&type=script&lang=js&"
export * from "./TaskGroup.vue?vue&type=script&lang=js&"
import style0 from "./TaskGroup.vue?vue&type=style&index=0&id=8d8d504e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8d504e",
  null
  
)

export default component.exports